/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PredictorOutput
 */
export interface PredictorOutput {
    /**
     * 
     * @type {string}
     * @memberof PredictorOutput
     */
    id: string;
    /**
     * 
     * @type {PredictorOutputDecisionEnum}
     * @memberof PredictorOutput
     */
    decision: PredictorOutputDecisionEnum;
    /**
     * 
     * @type {number}
     * @memberof PredictorOutput
     */
    confidence: number;
    /**
     * 
     * @type {boolean}
     * @memberof PredictorOutput
     */
    deleterious: boolean;
}


/**
 * @export
 */
export const PredictorOutputDecisionEnum = {
    Deleterious: 'DELETERIOUS',
    Benign: 'BENIGN'
} as const;
export type PredictorOutputDecisionEnum = typeof PredictorOutputDecisionEnum[keyof typeof PredictorOutputDecisionEnum];


/**
 * Check if a given object implements the PredictorOutput interface.
 */
export function instanceOfPredictorOutput(value: object): value is PredictorOutput {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('decision' in value) || value['decision'] === undefined) return false;
    if (!('confidence' in value) || value['confidence'] === undefined) return false;
    if (!('deleterious' in value) || value['deleterious'] === undefined) return false;
    return true;
}

export function PredictorOutputFromJSON(json: any): PredictorOutput {
    return PredictorOutputFromJSONTyped(json, false);
}

export function PredictorOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictorOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'decision': json['decision'],
        'confidence': json['confidence'],
        'deleterious': json['deleterious'],
    };
}

export function PredictorOutputToJSON(json: any): PredictorOutput {
    return PredictorOutputToJSONTyped(json, false);
}

export function PredictorOutputToJSONTyped(value?: PredictorOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'decision': value['decision'],
        'confidence': value['confidence'],
        'deleterious': value['deleterious'],
    };
}

